
export default {
  props: {
    tiles: { type: Array, default: () => [] },
    selectedTile: { type: String, default: "" },
    variants: { type: Object, required: true },
    label: { type: String, default: "" },
  },

  data() {
    return { internalSelectedTile: this.selectedTile };
  },

  watch: {
    selectedTile(value) {
      this.internalSelectedTile = value;
    },
  },

  methods: {
    handleClick(targetVariantId, tileLabel) {
      this.internalSelectedTile = tileLabel;
      this.$emit("select-variant-id", targetVariantId, this.label, tileLabel);
    },
  },
};
